var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"ripple",rawName:"v-ripple"}],staticClass:"text-center elevation-2 py-5 ",on:{"click":_vm.sendNumber}},[_c('p',{staticClass:"text-h4 font-weight-medium"},[_vm._v(_vm._s(_vm.number))])])}
var staticRenderFns = []

export { render, staticRenderFns }